import { CloseOutlined } from '@ant-design/icons';
import { useCallback, useEffect, useState } from 'react';

import { useCustomTranslation } from '../../hooks/custom-translation';
import { Body } from '../../styles/fonts';

import Modal from '../Modal';

import AgeGroupByGenderTab from './TabGroup/AgeGroupByGenderTab';
import CompanyParticipationTab from './TabGroup/CompanyParticipationTab';
import GeographicDistributionTab from './TabGroup/GeographicDistributionTab';
import IncomeBracketsTab from './TabGroup/IncomeBrackets';
import SocioDemographicTab from './TabGroup/SocioDemographicTab';
// import PeopleTab from './TabGroup/PeopleTab';
// import FinancialRiskTab from './TabGroup/FinancialRiskTab';
// import { Personas } from '../../services/personas';
// import { getPersonasData } from '../../services/personas/personas-service';

import {
  ActionBar,
  Body1,
  Button,
  Buttons,
  Column01,
  Column02,
  ModalImportDetails,
  ModalTabTitle,
  PageHeader,
  Sider1,
  TabGroup,
  TabGroupPane,
  Wrapper,
} from './styles';
// import PsychometricScoreTab from './TabGroup/PsychometricScore';
import { HelperDate } from '../../helpers/date';
import getErrors from '../../helpers/errors';
import { ShowFormMessage } from '../../helpers/message';
import {
  useGetAllDescriptiveAnalysisByOriginIdQuery,
  useUpdateSegmentationAnalysisMutation,
} from '../../services/descriptiveAnalysisReport';
import { usePostFileExportMutation } from '../../services/fileExport/file-export-service';

interface DescriptiveAnalysisModalProps {
  onCancel: () => void;
  visible: boolean;
  fileId?: string;
  fileTypeDataSource?: string;
}

const DescriptiveAnalysisModal = ({
  onCancel,
  visible,
  fileId,
  fileTypeDataSource,
}: DescriptiveAnalysisModalProps) => {
  const { tModalDescriptiveAnalysis } = useCustomTranslation(
    'modalDescriptiveAnalysis',
  );

  const [, setDataSourceId] = useState<string>();
  const [, setDataSource] = useState<string>();

  const { data: descriptiveAnalysisData } =
    useGetAllDescriptiveAnalysisByOriginIdQuery({
      origin: fileTypeDataSource,
      originId: fileId,
    });

  // const [personasProfileData, setPersonasProfileData] = useState<{
  //   personas: Personas[];
  // }>();

  // useEffect(() => {
  //   getPersonasData().then(profile => setPersonasProfileData(profile));
  // }, []);

  const handleCancel = () => {
    onCancel();
  };

  const [, configPostFileExport] = usePostFileExportMutation();
  const [, configUpdateSegmentationAnalysis] =
    useUpdateSegmentationAnalysisMutation();

  useEffect(() => {
    setDataSource(descriptiveAnalysisData?.dataSource);
    setDataSourceId(descriptiveAnalysisData?.dataSourceId);
  }, [descriptiveAnalysisData]);

  // const handleUpdateAnalysis = useCallback(() => {
  //   if (fileTypeDataSource && fileId) {
  //     updateSegmentationAnalysis({
  //       originId: fileId,
  //       origin: fileTypeDataSource,
  //     });
  //   }
  // }, [fileId, fileTypeDataSource, updateSegmentationAnalysis]);

  const showMessagePostFileExport = useCallback(() => {
    const { isSuccess, isError, error } = configPostFileExport;

    let errors: any;

    if (error) {
      const { data: errorData }: any = error;
      errors = errorData;
    }

    ShowFormMessage.SuccessOrError({
      status: {
        isSuccess,
        isError,
      },
      config: {
        successMessage: 'Relatório exportado com sucesso.',
        errorMessage: error ? getErrors(errors.errors) : '',
      },
    });
    if (isSuccess) {
      onCancel();
    }
  }, [configPostFileExport, onCancel]);

  useEffect(showMessagePostFileExport, [showMessagePostFileExport]);

  const showMessageUpdateAnalysis = useCallback(() => {
    const { isSuccess, isError, error } = configUpdateSegmentationAnalysis;

    let errors: any;

    if (error) {
      const { data: errorData }: any = error;
      errors = errorData;
    }
    ShowFormMessage.SuccessOrError({
      status: {
        isSuccess,
        isError,
      },
      config: {
        successMessage: 'Análise atualizada com sucesso.',
        errorMessage: error ? getErrors(errors.errors) : '',
      },
    });
    if (isSuccess) {
      onCancel();
    }
  }, [configUpdateSegmentationAnalysis, onCancel]);

  useEffect(showMessageUpdateAnalysis, [showMessageUpdateAnalysis]);

  return (
    <>
      <Modal
        visible={visible}
        title={null}
        footer={null}
        closable={false}
        width="57rem"
      >
        <ModalImportDetails>
          <Sider1 />
          {descriptiveAnalysisData ? (
            <Wrapper>
              <PageHeader>
                <Column01>
                  <ModalTabTitle weight="bold">
                    {tModalDescriptiveAnalysis('descriptive_analysis')}
                  </ModalTabTitle>
                  {/*  <H4 weight="medium">{data.file_name}</H4> */}
                </Column01>
                <Column02>
                  {/* <Button type="text" icon={<FullscreenOutlined />} /> */}

                  <Button
                    type="text"
                    icon={<CloseOutlined />}
                    onClick={handleCancel}
                  />
                </Column02>
              </PageHeader>

              <Body1>
                <TabGroup tabPosition="left" type="line" size="small">
                  <TabGroupPane
                    tab={tModalDescriptiveAnalysis('socio-demographic')}
                    key="0"
                  >
                    <SocioDemographicTab
                      socioDemographic={
                        descriptiveAnalysisData.sociodemographic
                      }
                    />
                  </TabGroupPane>
                  <TabGroupPane
                    tab={tModalDescriptiveAnalysis('income_brackets')}
                    key="1"
                  >
                    <IncomeBracketsTab
                      income={descriptiveAnalysisData.income}
                    />
                  </TabGroupPane>
                  <TabGroupPane
                    tab={tModalDescriptiveAnalysis('geographic_distribution')}
                    key="2"
                  >
                    <GeographicDistributionTab
                      geographicDistribution={
                        descriptiveAnalysisData.geographicDistribution
                      }
                    />
                  </TabGroupPane>
                  <TabGroupPane
                    tab={tModalDescriptiveAnalysis('age_group_by_gender')}
                    key="3"
                  >
                    <AgeGroupByGenderTab
                      ageGroupsByGender={
                        descriptiveAnalysisData.sociodemographic
                          ?.ageGroupsByGender || []
                      }
                    />
                  </TabGroupPane>
                  <TabGroupPane
                    tab={tModalDescriptiveAnalysis('company_participation')}
                    key="4"
                  >
                    <CompanyParticipationTab
                      companyParticipations={
                        descriptiveAnalysisData.sociodemographic
                          ?.companyParticipations || []
                      }
                    />
                  </TabGroupPane>
                  {/* <TabGroupPane
                    tab={tModalDescriptiveAnalysis('people')}
                    key="3"
                  >
                    <PeopleTab
                      personasData={descriptiveAnalysisData.personas}
                      personasProfileData={personasProfileData}
                    />
                  </TabGroupPane> */}
                  {/* <TabGroupPane
                    tab={tModalDescriptiveAnalysis('financial_risk')}
                    key="4"
                  >
                    <FinancialRiskTab
                      financialRisks={descriptiveAnalysisData.financialRisks}
                    />
                  </TabGroupPane> */}
                  {/* <TabGroupPane
                    tab={tModalDescriptiveAnalysis('psychometric_score')}
                    key="5"
                  >
                    <PsychometricScoreTab
                      psychometricScore={
                        descriptiveAnalysisData.psychometricScore
                      }
                    />
                  </TabGroupPane> */}
                </TabGroup>
              </Body1>
              <ActionBar>
                <Body weight="regular">
                  {tModalDescriptiveAnalysis('analysis_carried_out_on')}
                  {HelperDate.formateDate(
                    new Date(descriptiveAnalysisData.analysisDate),
                  )}
                </Body>
                <Buttons>
                  {/* {fileTypeDataSource && (
                    <UpdateAnalysisButton
                      onClick={handleUpdateAnalysis}
                      size="large"
                    >
                      {tModalDescriptiveAnalysis('update_analysis')}
                    </UpdateAnalysisButton>
                  )} */}
                </Buttons>
              </ActionBar>
            </Wrapper>
          ) : null}
        </ModalImportDetails>
      </Modal>
    </>
  );
};

export default DescriptiveAnalysisModal;
